import ClothesComposition from './ClothesComposition'
export default ClothesComposition
